import { createColorPanel } from '../../common/utils'
import { ToolbarSplitDropdownElement } from './ToolbarSplitDropdownElement'

const colorConfig = [
  ['#000000', '#262626', '#595959', '#8c8c8c', '#bfbfbf', '#d9d9d9', '#e9e9e9', '#f5f5f5', '#fafafa', 'transparent'],
  ['#f5222d', '#fa541c', '#fa8c16', '#fadb14', '#52c41a', '#13c2c2', '#1890ff', '#2f54eb', '#722ed1', '#eb2f96'],
  ['#ffe8e6', '#ffece0', '#ffefd1', '#fcfcca', '#e4f7d2', '#d3f5f0', '#d4eefc', '#dee8fc', '#efe1fa', '#fae1eb'],
  ['#ffa39e', '#ffbb96', '#ffd591', '#fffb8f', '#b7eb8f', '#87e8de', '#91d5ff', '#adc6ff', '#d3adf7', '#ffadd2'],
  ['#ff4d4f', '#ff7a45', '#ffa940', '#ffec3d', '#73d13d', '#36cfc9', '#40a9ff', '#597ef7', '#9254de', '#f759ab'],
  ['#cf1322', '#d4380d', '#d46b08', '#d4b106', '#389e0d', '#08979c', '#096dd9', '#1d39c4', '#531dab', '#c41d7f'],
  ['#820014', '#871400', '#873800', '#614700', '#135200', '#00474f', '#003a8c', '#061178', '#22075e', '#780650'],
]

export class ToolbarBackgroundElement extends ToolbarSplitDropdownElement {
  public currentColor: string = colorConfig[0][0]
  public colorIndicator: HTMLDivElement | undefined
  public override setFormat(format: { [key: string]: Set<any> }): void {
    this.overlayElement.querySelectorAll('.toolbar-color-item.selected').forEach((item) => {
      item.classList.remove('selected')
    })
    if (format[this.name]) {
      this.overlayElement.querySelectorAll('.toolbar-color-item').forEach((item) => {
        if (format[this.name].has((item as HTMLElement).dataset.value)) {
          item.classList.add('selected')
        }
      })
    }
  }

  protected override initEvent() {
    super.initEvent()
    this.colorIndicator = document.createElement('div')
    this.colorIndicator.classList.add('color-indicator')
    this.colorIndicator.style.backgroundColor = colorConfig[0][0]
    this.entryElement.append(this.colorIndicator)
    this.overlayElement.addEventListener('click', (event: MouseEvent) => {
      this.currentColor = (event.target as HTMLElement).dataset.value as string
      this.colorIndicator && (this.colorIndicator.style.backgroundColor = this.currentColor)
      this.emitClick()
    })
  }

  protected override emitClick() {
    this.emit('choose', this.currentColor)
  }

  protected override initDom() {
    super.initDom()
    this.entryElement.classList.add('toolbar-split-dropdown-background')
    this.overlayElement.append(createColorPanel(colorConfig))
    this.overlayContainer.append(this.overlayElement)
  }
}
